module.exports = __webpack_public_path__ + "img/ataviti-emblem.e3041d78.svg";